module.exports = __webpack_public_path__ + "img/mail.5766bb2d.svg";